import React from "react";
import { motion } from "motion/react";
import { Badge } from "../../ui/Badge";
import { Card, CardContent } from "../../ui/Card";
import { Button } from "../../ui/Button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ServiceSection = ({ services }) => {
  return (
    <section className="py-5 bg-light">
      <div className="container px-3">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-5"
        >
          <Badge className="mb-2 bg-primary text-white border-0">
            Our Expertise
          </Badge>
          <h2 className="display-6 fw-bold mb-3 text-primary">
            Premium Digital Services
          </h2>
          <p className="lead text-muted fw-500 mb-4">
            We offer scalable, future-ready digital services that combine smart
            strategy with powerful technology helping your business innovate,
            grow, and lead in a digital-first world.
          </p>
        </motion.div>

        <div className="row g-4">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="col-sm-12 col-md-4"
              >
                <Card className="h-100 border shadow-sm rounded-3 overflow-hidden">
                  <CardContent className="p-4">
                    <div
                      className="d-flex align-items-center justify-content-center mb-3"
                      style={{
                        width: "4rem",
                        height: "4rem",
                        borderRadius: "1rem",
                        background: service.gradient,
                      }}
                    >
                      <Icon className="text-white" size={24} />
                    </div>
                    <h3 className="h5 fw-semibold mb-2">{service.title}</h3>
                    <p className="text-muted mb-3">{service.description}</p>
                    <Link to={service.link} variant="ghost" className="btn btn-link p-0">
                      Learn More <ArrowRight className="ms-2" />
                    </Link>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
